var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.075,
    height: 24.866,
    viewBox: "0 0 26.075 24.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star-sharp-svgrepo-com",
    d: "M14.91,4.683c.334-.961.5-1.441.748-1.574a.721.721,0,0,1,.685,0c.247.133.414.613.748,1.574L19.3,11.034a1.642,1.642,0,0,0,.228.512.721.721,0,0,0,.281.2,1.641,1.641,0,0,0,.557.059l6.722.137c1.017.021,1.525.031,1.728.225a.721.721,0,0,1,.211.651c-.05.276-.455.583-1.266,1.2L22.4,18.081a1.647,1.647,0,0,0-.416.375.722.722,0,0,0-.107.33,1.645,1.645,0,0,0,.116.548l1.947,6.435c.294.973.442,1.46.32,1.713a.722.722,0,0,1-.554.4c-.278.037-.7-.253-1.53-.834l-5.519-3.84a1.647,1.647,0,0,0-.485-.28.722.722,0,0,0-.347,0,1.647,1.647,0,0,0-.486.28l-5.519,3.84c-.835.581-1.252.871-1.53.834a.721.721,0,0,1-.554-.4c-.121-.253.026-.739.32-1.713l1.947-6.435a1.643,1.643,0,0,0,.116-.548.722.722,0,0,0-.107-.33,1.646,1.646,0,0,0-.416-.375L4.241,14.02c-.81-.615-1.216-.922-1.266-1.2a.721.721,0,0,1,.212-.651c.2-.194.711-.2,1.728-.225l6.722-.137a1.642,1.642,0,0,0,.557-.059.721.721,0,0,0,.281-.2,1.642,1.642,0,0,0,.228-.512Z",
    transform: "translate(-2.963 -3.023)",
    fill: "#e91e63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSharp);
export default __webpack_public_path__ + "static/media/star-sharp.943038d764008f35b3fc3c1b3464ee24.svg";
export { ForwardRef as ReactComponent };